import React from "react";
import { Spinner } from "react-bootstrap";

export function LoadingSpinner({
  message,
  size = 48,
  direction = "row", // "row" (horizontal) oder "column" (vertikal)
  gap = 12,
  ...rest
}) {
  // Bootstrap nutzt "flex-row" und "flex-column"
  const flexClass = direction === "column" ? "flex-column" : "flex-row";

  return (
    <div
      className={`loading-spinner-container d-flex ${flexClass} align-items-center`}
      style={{ gap: gap }}
      {...rest}
    >
      <Spinner
        animation="border"
        role="status"
        style={{ width: size, height: size }}
      >
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      {message && <div className="loading-spinner-message">{message}</div>}
    </div>
  );
}